export const SERVICE_RATE = 114;
export const HOURS_DAY = 7;
export const CDN_URL = "https://media.choice.graphics/";
export const TAX_RATE = 0.05;
// Down Payment (Reservation Fee): the share of the tax-inclusive grand total a
// customer pays up front to hold a service booking. Applied to the final invoice
// at drop-off, or forfeited on a no-show. 20% mirrors the long-standing admin
// QuickBookingDrawer convention (was a magic `* 0.2`).
export const RESERVATION_FEE_RATE = 0.2;
// Restocking fee for PAID product orders that get cancelled (B1 decision,
// 2026-07-19): customers pay the full total at checkout; on cancellation,
// 20-30% of the order total is withheld from the refund. Disclosed in the
// cart summary and at checkout Review; enforced in the refund path.
export const ORDER_RESTOCKING_FEE_MIN_RATE = 0.2;
export const ORDER_RESTOCKING_FEE_MAX_RATE = 0.3;
export const DEFAULT_CURRENCY = 'CAD';
export const IMAGE_SIZES = [320, 640, 800, 1024, 1280, 1600, 1920, 2048, 2560, 3840]

